import * as React from 'react'
import Animation from '../containers/Animation'
import styled from '../theme/styled'
import { IfrontPageProps } from '../types/index'

const Wrapper = styled.div`
  text-align: center;
  margin-top: ${({ theme }) => `${theme.navbar.height.short}`};
  margin-bottom: 90px;
  flex: 1 0 auto;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
    margin-top: ${({ theme }) => `${theme.navbar.height.tall}`}
  }
`
const makeRequest = (viewId: number, id: number) => ({
  view: viewId,
  request: {
    method: 'GET',
    url: process.env.NODE_ENV === 'development' ? 'http://localhost:7070/snapshot_' + viewId + '_' + id + '.json'
      : 'http://go.vaisala.com/keravaradar/snapshot/snapshot_' + viewId + '_' + id + '.json'
  }
})

class FrontPage extends React.Component<IfrontPageProps, {}> {
  constructor(props: IfrontPageProps) {
    super(props)
  }

  public componentDidMount() {
    /*
    Frontend makes 24 requests for the snapshots.
    Its not a very good solution since if you ever modify the amount of snapshots/views in the backend,
    you need to edit this as well.
    A possible improvement would be for the backend to save a text file in addition to the snapshots which would
    list every saved snapshots name.
    The frontend would then first get that file and make the subsequent requests based on that file.
    */
    for (let i = 0; i < 12; i = i + 1) {
      this.props.getSnapshot(makeRequest(1, i))
      this.props.getSnapshot(makeRequest(2, i))
    }
  }

  public render() {
    return (
      <Wrapper>
        <Animation />
      </Wrapper>
    )
  }
}

export default FrontPage



// WEBPACK FOOTER //
// ./src/pages/FrontPage.tsx